// extracted by mini-css-extract-plugin
module.exports = {"contactData":"ContactData_contactData__32N8N","input":"ContactData_input__3XwIG"};